function detectPhysicalTablet(userAgent: string): boolean {
  const isAndroidTablet = /Android(?!(.*(Mobile)))/i.test(userAgent);
  const isIPad = /iPad/i.test(userAgent);
  return isAndroidTablet || isIPad;
}

const isPhysicalTablet =
  typeof navigator !== 'undefined' && detectPhysicalTablet(navigator.userAgent);

export const useIsPhysicalTabletDetection = () => isPhysicalTablet;
